<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <!--
      <sign-up :toggle="toggleForm" v-if="formState === 'signUp'"></sign-up>
      <sign-in v-if="formState === 'signIn'"></sign-in>
      -->
      <div class="md-layout text-center">
        <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100">
          <div class="logo-container">
            <img src="img/fortis-payments-light-logo.png" title="" id="logo" />
          </div>
        </div>
      </div>
      <login-card header-color="atlas">
        <h4 class="title text-center" slot="title"><strong>ATLAS</strong></h4>
        <!--
        <md-button
          slot="buttons"
          href="#facebook"
          class="md-just-icon md-simple md-white"
        >
          <i class="fab fa-facebook-square"></i>
        </md-button>

        <md-button
          slot="buttons"
          href="#twitter"
          class="md-just-icon md-simple md-white"
        >
          <i class="fab fa-twitter"></i>
        </md-button>
        -->
        <!-- <md-button
          slot="buttons"
          href="#google"
          class="md-just-icon md-simple md-black"
        >
          <i class="fab fa-google-plus-g"></i>
        </md-button> -->

        <h4 slot="description" class="description"><strong>{{ formState === "signIn" ? "Log In" : "Change Password" }}</strong></h4>

        <template v-if="formState === 'signIn'">

          <md-field class="md-form-group" slot="inputs" :class="[
                    { 'md-error': $v.form.username.$error },
                    { 'md-valid': !$v.form.username.$invalid },
                    { '_uiKitInput': isUiKit },
                  ]">
            <md-icon class="left-icon">account_circle</md-icon>
            <md-input v-model.trim="$v.form.username.$model" type="email" placeholder="Email"></md-input>
            <md-icon v-if="$v.form.username.$error">clear</md-icon>
            <md-icon v-else-if="!$v.form.username.$invalid">done</md-icon> 
          </md-field>
          <md-field class="md-form-group" slot="inputs" :class="[
                    { 'md-error': $v.form.password.$error },
                    { 'md-valid': !$v.form.password.$invalid },
                    { '_uiKitInput': isUiKit },
                  ]">
            <md-icon class="left-icon">lock_outline</md-icon>
            <md-input v-model.trim="$v.form.password.$model" type="password" placeholder="Password"></md-input>
            <md-icon v-if="$v.form.password.$error">clear</md-icon>
            <md-icon v-else-if="!$v.form.password.$invalid">done</md-icon> 
          </md-field>
          <md-button v-on:click="signIn" :disabled="$v.form.$invalid || promisePending" slot="footer" class="atlas-button-blue">
            Submit
          </md-button>
        </template>


        <template v-if="formState === 'newPassword'">

          <md-field class="md-form-group" slot="inputs" :class="[
                    { 'md-error': $v.formNewPassword.password.$error },
                    { 'md-valid': !$v.formNewPassword.password.$invalid },
                  ]">
            <md-icon>lock_outline</md-icon>
            <label>New Password...</label>
            <md-input v-model.trim="$v.formNewPassword.password.$model" type="password"></md-input>
            <md-icon v-if="$v.formNewPassword.password.$error">clear</md-icon>
            <md-icon v-else-if="!$v.formNewPassword.password.$invalid">done</md-icon> 
          </md-field>
          <md-field class="md-form-group" slot="inputs" :class="[
                    { 'md-error': $v.formNewPassword.confirm_password.$error },
                    { 'md-valid': !$v.formNewPassword.confirm_password.$invalid },
                  ]">
            <md-icon>lock_outline</md-icon>
            <label>Confirm Password...</label>
            <md-input v-model.trim="$v.formNewPassword.confirm_password.$model" type="password"></md-input>
            <md-icon v-if="$v.formNewPassword.confirm_password.$error">clear</md-icon>
            <md-icon v-else-if="!$v.formNewPassword.confirm_password.$invalid">done</md-icon> 
          </md-field>
          
          <md-button v-on:click="changePassword" :disabled="$v.formNewPassword.$invalid || promisePending" slot="footer" class="atlas-button-blue">
            Submit
          </md-button>
        </template>

        <a slot="other-options" href="#/forgotPassword" class="anchor-box">Forgot Password</a>
        

      </login-card>
      <md-dialog-alert
      :md-active.sync="dialogStatus"
      :md-content="errorMessage" 
      md-confirm-text="Ok!" 
      @md-closed="errorMessage = ''"/>
    </div>
    <div class="dynamicList-loading"
          v-show="promisePending">
          <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>

    <md-snackbar md-position="center" :md-active.sync="isSnackbarOpen" md-persistent>
      <span>{{ errorMessage }}</span>
    </md-snackbar>

  </div>
</template>
<script>

import { Auth, API, graphqlOperation } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";
import { LoginCard } from "@/components";
// Form validations
import { required, numeric, minLength, email, sameAs } from "vuelidate/lib/validators";

import * as queries from '@/graphql/queries';
import * as mutations from '@/graphql/mutations';
import aws_exports from "../aws-exports";

const AWS = require('aws-sdk');
const appsync = require('aws-appsync');
const AUTH_TYPE = require('aws-appsync-auth-link/lib/auth-link').AUTH_TYPE;

const graphqlClient = new appsync.AWSAppSyncClient({
  url: aws_exports.aws_appsync_graphqlEndpoint,
  region: aws_exports.aws_appsync_region,
  auth: {
    type: AUTH_TYPE.AWS_IAM,
    credentials: AWS.config.credentials
  },
  disableOffline: true
});
console.log(graphqlClient);

export default {
  props: {
    isUiKit: {
      type: Boolean,
      default: () => true,
    },
  },
  components: {
   LoginCard,
  },
  data() {
    return {
      signInResponse: null,
      formState: "signIn",
      errorMessage: "",
      promisePending: false,
      dialogStatus: false,
      form: {
        username: null,
        password: null
      },
      formNewPassword: {
        password: null,
        confirm_password: null
      },
      isSnackbarOpen: false,
      errorMessage: null,
      // txt: {
      //   form: {
      //     signUp: {
      //       title: "Account Registration",
      //       toggleBtnLabel: "Already signed up? Sign In"
      //     },
      //     signIn: {
      //       title: "Login to Your Account",
      //       toggleBtnLabel: "Need an account? Sign Up"
      //     }
      //   }
      // }
    };
  },
  validations() {
      return {
        form: {
          username: {
            required, 
            email
          },
          password: {required, minLength: minLength(6)},
        },
        formNewPassword: {
          password: {required, minLength: minLength(6)},
          confirm_password: {required, sameAsPassword: sameAs('password')}
        }
      }
  },
  // computed: {
  //   title: function() {
  //     return this.txt.form[this.formState].title;
  //   },
  //   toggleFormButtonLabel: function() {
  //     return this.txt.form[this.formState].toggleBtnLabel;
  //   }
  // },
  methods: {
    // toggleForm() {
    //   this.formState = this.formState === "signUp" ? "signIn" : "signUp";
    // },
    /**
     * Search user in DynamoDB
     * @returns {Promise}
     */
    async isValidUser() {
      return new Promise(async (resolve, reject) => {
        let opertionSearchUsers = graphqlOperation(queries['searchUsers'], {
          filter: {
            email: { eq: this.form.username.toLowerCase() }
          }
        });
        await API.graphql(opertionSearchUsers)
          .then(response => {
            const data = this.$reduce(response, 'data.searchUsers.items.0');
            if (data && data.id) {
              return resolve(true);
            }
            return reject(false);
          })
          .catch(err => {
            return reject(err);
          });
      });
    },
    /**
     * Log off user using Amplify and destroy Session
     * @returns {void}
     */
    signOut() {
      this.$Amplify.Auth.signOut();
      this.$set(this, '$Session', null);
    },
    async signIn() {
      this.promisePending = true;
      try{
        const { username, password } = this.form;
        const emailId = username.toLowerCase()
        await Auth.signIn(emailId, password).then(async user => {
          this.signInResponse = user;
          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.formState = "newPassword";
            /**
             * Using SetTimeout to reset validation 
             * @link https://vuelidate.js.org/#sub-delayed-validation-errors
             */
            setTimeout(() => {
              this.$v.formNewPassword.$reset();
            }, 100);            
          } else {
            const isValidUser = await this.isValidUser().catch(err => {
              if (err.message) {
                this.errorMessage = err.message;
              } else {
                this.errorMessage = 'Invalid User';
              }
            });
            if (!isValidUser) {
              this.promisePending = false;
              this.isSnackbarOpen = true;
              this.signOut();
              return;
            }
          }
        }).catch(e => {
          console.log(e);
          this.dialogStatus = true;
          this.errorMessage = e.message;
        });
      } catch(e) {
        this.dialogStatus = true;
        this.errorMessage = e.message;
      }
      this.promisePending = false;
      console.log(this.errorMessage);
      console.log(this.formState);
      if (!this.errorMessage && this.formState != 'newPassword') {
        AmplifyEventBus.$emit("authState", "signedIn");
        if(!this.$route.query.redirect){
          this.$router.push("/dashboard");// POST LOGIN DESTINATION!               
        }else{
          this.$router.push(this.$route.query.redirect);
        }
      }
    },
    async changePassword() {
      this.promisePending = true;
      try{
        const { password } = this.formNewPassword;
        await Auth.completeNewPassword(
          this.signInResponse,// the Cognito User Object
          password,           // the new password
        ).then(async user => {
          // at this time the user is logged in if no MFA required
          console.log(user);
          
          try {

            let ts = new Date().toISOString();
            
            let filter = {
              esQuery: JSON.stringify({"match": {"cogUsername": user.username }})
            };            
            let gqlSearchRequest = graphqlOperation(queries['searchUsers'], {filter});
            const mutateSearchResponse = await API.graphql(gqlSearchRequest);
            console.log("Search User was successful.", mutateSearchResponse);

            console.log(mutateSearchResponse.data.searchUsers.total)
            console.log(mutateSearchResponse.data.searchUsers.items[0].id)

            if(mutateSearchResponse.data.searchUsers.total == 1)
            {
              let data = {
                id: mutateSearchResponse.data.searchUsers.items[0].id,
                cogUserStatus: 'CONFIRMED',
                cogEmailVerified: true,
                updatedAt: ts,
              };

              let gqlRequest = graphqlOperation( mutations['updateUser'], {input: data});
              const mutateResponse = await API.graphql(gqlRequest);
              console.log("Update User was successful.", mutateResponse);
            }
 
          } catch (error) {
            console.log("Signup Create User--------------",JSON.stringify(error));
          }

        }).catch(e => {
          console.log(e);
          this.dialogStatus = true;
          this.errorMessage = e.message;
        });
      } catch(e) {
        this.dialogStatus = true;
        this.errorMessage = e.message;
      }
      this.promisePending = false;
      console.log(this.errorMessage);
      console.log(this.formState);
      if (!this.errorMessage) {
        if (!this.errorMessage) {
          AmplifyEventBus.$emit("authState", "signedIn");
          if(!this.$route.query.redirect){
            this.$router.push("/dashboard");// POST LOGIN DESTINATION!               
          }else{
            this.$router.push(this.$route.query.redirect);
          }
        }
      }
    }
  }
};
</script>

<style lang="css" scoped>
 .dynamicList-loading {
    position: absolute;
    top: 200px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
    z-index:9999;
  }
  .anchor-box {
    display: block;
    padding: 5px;
  }
  #logo {
    width: 100%;
    height: auto;
  }
  .logo-container{
    width: 45%;
    margin: 15% auto;
  }
</style>